import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListSuspensionPointSetting = createAsyncThunk(
    "suspensionPointSetting/getListSuspensionPointSetting",
    async ({ currentPage, pageSize}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/suspension-point-settings?has_paginate&size=${pageSize}&page=${currentPage}`;
            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);

export const updateSuspensionPointSetting = createAsyncThunk(
  "suspensionPointSetting/updateSuspensionPointSetting", // Đổi tên hành động cho phù hợp
  async ({ id, data }, { rejectWithValue }) => { // Lấy đối tượng có `id` và `data`
    try {
      const response = await http.put(`/api/v1/serviceconnect/suspension-point-settings/${id}`, data); // Gọi API PUT
      return response.data; // Trả về kết quả thành công
    } catch (error) {
      return rejectWithValue(error.response.data); // Trả về lỗi nếu có
    }
  }
);

export const createSuspensionPointSetting = createAsyncThunk(
  "suspensionPointSetting/createSuspensionPointSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/suspension-point-settings`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteSuspensionPointSetting = createAsyncThunk(
  "suspensionPointSetting/deleteSuspensionPointSetting",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/api/v1/serviceconnect/suspension-point-settings/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);